<template>
  <div class="logged-header">
    <logo v-if="!noLogo" class="logo-instance" type="logged"></logo>
    <a class="new-notice" @click="setAnnouncement()" href="/doc/operating_new.html" target="_blank" v-if="showNotice && isCostCloud">
      <div class="notice-arrow" :class="{infinite: isInfinite}"></div>
    </a>
    <div class="preview-file-name" v-if="pageTitle">
      {{pageTitle}}
    </div>
    <template v-else>
      <!-- 管理员账号、个人账号 不显示顶级菜单 -->
      <template v-if="menuList.length > 1">
      <!--<template v-if="![1, 5, 6].includes(user.role)">-->
        <a href="javascript: void(0);" v-for="(item, idx) in menuList" :key="'block_' + idx"
           @click="switchModule(item)"
           class="relative menu-item"
           :class="[nowActive === item.path ? 'active' : '']">
          {{item.title}}
          <template v-if="item.path === '/applications' && Array.isArray(item.children) && item.children.length">
            <div class="absolute submenu">
              <ul>
                <li class="flex"
                    v-for="child in item.children"
                    :key="'submenu_' + child.id"
                    @click.stop="switchModule(child, true)">
                  <div :class="['submenu-icon', colorMap[child.icon]]">
                    <i :class="child.icon"></i>
                  </div>
                  <div class="submenu-title flex-1 ellipsis">{{child.title}}</div>
                  <div class="submenu-mask" v-if="typeof applicationPermission[child.permissionId] === 'boolean' && !applicationPermission[child.permissionId]">未购买</div>
                </li>
              </ul>
            </div>
          </template>
        </a>
      </template>

      <div class="right-options f-cb">
        <!-- 用户信息下拉框 -->
        <div class="user-info--cont f-cb" @mouseenter="fetchPersonalStorage">
          <span class="portrait" :style="portraitStyle"></span>
          <!--<i class="r2-icon-nav_expand_more"></i>-->
          <!--<i  v-if="newUpload || newFeedback" :key="refreshIndex" class="red-point"></i>-->
          <div class="switch-cont" id="userInfoSwitchCont">
            <div class="switch-cont--main">
              <!-- 个人信息区域 -->
              <div class="info--cont f-cb">
                <span class="portrait" :style="portraitStyle"></span>
                <div class="info--cont__inner">
                  <div class="user-name ellipsis" :title="userInfo.userName">
                    {{userInfo.userName}}
                  </div>
                  <div class="space-process"
                       :class="{'is-warning': (((+capacity.personal.used) + (+capacity.personal.staffUsed)) / capacity.personal.total * 100) > 90 || (capacity.company.used / capacity.company.total * 100) > 90}">
                    <div class="person-space inline-block" style="width: 100%;" v-if="(((+capacity.personal.used) + (+capacity.personal.staffUsed)) / capacity.personal.total * 100) > 100 || (capacity.company.used / capacity.company.total * 100) > 100"></div>
                    <template v-else>
                      <div class="person-space inline-block" :style="{
                          width: (user.role === 1 ? (capacity.company.used / capacity.company.total * 100) :
                           (capacity.personal.used / capacity.personal.total * 100))  + '%'
                        }"></div>
                      <div class="enterprise-space inline-block relative" :style="{
                          width: (capacity.personal.staffUsed / capacity.personal.total * 100) + '%'
                        }" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false"
                           v-if="![1, 5].includes(user.role)">
                        <div class="tooltip-box" v-if="capacity.personal.staffUsed" :style="{left: Math.floor(94 * (capacity.personal.staffUsed / capacity.personal.total)) - 40 + 'px'}">
                          <div class="tooltip">
                            其他文件 {{capacity.personal.staffUsed}}G
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="space-info">
                    <template v-if="user.role === 5">
                      {{capacity.personal.used}}G / {{capacity.personal.total}}G
                    </template>
                    <template v-else-if="user.role === 1">
                      {{capacity.company.used}}G / {{capacity.company.total}}G
                    </template>
                    <template v-else>
                      {{capacity.personal.used}}G / {{capacity.personal.total}}G
                    </template>
                  </div>
                </div>
              </div>
              <!-- 友情链接区域 -->
              <ul class="link-list">
                <li v-if="[2, 3, 4].includes(user.role) && isCostCloud">
                  <a href="javascript: void(0);" @click.stop="clickHandle('import')">
                    导入个人账号资料
                    <i class="r2-icon-nav_chevron_right"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://account.glodon.com/ent/user#/dashboard/firstPage"
                     @click.stop="clickHandle('open', 'userCenter')">
                    用户中心
                    <i class="r2-icon-nav_chevron_right"></i>
                  </a>
                </li>
                <!--<li>-->
                  <!--<a target="_blank" href="https://account.glodon.com/security/emailbind"-->
                     <!--@click.stop="clickHandle('open', 'securityCenter')">-->
                    <!--安全中心-->
                    <!--<i class="r2-icon-nav_chevron_right"></i>-->
                  <!--</a>-->
                <!--</li>-->
                <!--跳转用户中心登录改造-->
                <!--<li>-->
                  <!--<a href="javascript: void(0);" @click.stop="clickHandle('open', 'userCenter', '/enterprise')">-->
                    <!--用户中心-->
                    <!--<i class="r2-icon-nav_chevron_right"></i>-->
                  <!--</a>-->
                <!--</li>-->
                <!--<li>-->
                  <!--<a href="javascript: void(0);" @click.stop="clickHandle('open', 'securityCenter', '/security/emailbind')">-->
                    <!--安全中心-->
                    <!--<i class="r2-icon-nav_chevron_right"></i>-->
                  <!--</a>-->
                <!--</li>-->
                <template v-if="isCostCloud">
                  <li>
                    <a href="javascript: void(0);"
                       @click.stop="clickHandle('jumping', 'productCenter')">
                      内容中心
                      <i class="r2-icon-nav_chevron_right"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript: void(0);"
                       @click.stop="clickHandle('downloadHelpDoc')">
                      帮助文档
                      <i class="r2-icon-nav_chevron_right"></i>
                    </a>
                  </li>
                  <li v-if="user.role !== 6">
                    <a href="javascript: void(0);"
                       @click.stop="clickHandle('jumping', 'Upload')">
                      历史上传
                      <!--<span v-if="newUpload" :key="refreshIndex" class="red-point red-point-history" style="left: 80px;"></span>-->
                      <i class="r2-icon-nav_chevron_right"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript: void(0);"
                       @click.stop="clickHandle('jumping', 'Feedback')">
                      意见反馈
                      <i class="r2-icon-nav_chevron_right"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="http://jubao.glodon.com/?code=321"
                       @click.stop="clickHandle('open', 'userAdvice')">
                      举报投诉
                      <i class="r2-icon-nav_chevron_right"></i>
                    </a>
                  </li>
                </template>
                <li class="logout">
                  <a href="javascript: void(0);"
                     @click.stop="clickHandle('logout')">
                    退出
                  </a>
                </li>
              </ul>
            </div>
            <i></i>
          </div>
        </div>
        <template v-if="isCostCloud">
          <!-- 试用中心 -->
          <div v-if="user.role !== 5" :class="['trial-center', showTrialCenterSwitch ? 'show--switch-content' : '']">
            <a v-if="user.role !== 6" href="javascript: void(0);" class="r2-icon-nav_apps notice prolink-btn"></a>
            <div v-if="user.role !== 6" :class="['switch-content', trialCenterList.length ? '' : 'switch-content__null']">
              <i class="icon-up"></i>
              <div class="switch-head">
                {{trialCenterList.length ? '全新云应用，点击了解更多' : '暂无推荐的新应用'}}
              </div>
              <div class="switch-box" v-if="trialCenterList.length">
                <ul style="max-height: 320px; overflow-y: auto;">
                  <li v-for="(trialItem, idx) in trialCenterList" :key="idx">
                    <a href="javascript: void(0);" class="flex"
                       :title="trialItem.name"
                       @click="trialCenterItemClickHandle(trialItem)">
                      <span class="icon" :style="{backgroundImage: 'url('+ trialItem.icon +')'}"></span>
                      <!-- <img class="icon" :src="trialItem.icon"> -->
                      <span class="flex-1 ellipsis-1 text-align-left">{{trialItem.name}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 消息小铃铛 -->
          <a  v-if="user.role !== 6" href="javascript: void(0);" @click.stop="clickHandle('readMessage')" id="notice_button"
              :class="['r2-icon-social_notifications_none notice', {'tips': newMessage}, {'rock': showAnimate}]">
          </a>
          <!--我是管理员-->
          <div class="admin-icon--cont" v-if="+userInfo.role > 1 && +userInfo.role < 5">
            <a href="javascript: void(0);" class="r2-icon-qiehuan" @click.stop="clickHandle('loginAsAdmin')"></a>
            <div class="title-tip">
              我是管理员
              <i></i>
            </div>
          </div>
          <!--邀请人员加入企业-->
          <!--<div class="admin-icon&#45;&#45;cont" v-if="[1, 2, 3, 4].includes(userInfo.role)">-->
            <!--<a href="javascript: void(0);" class="r2-icon-yaoqing" @click.stop="clickHandle('invite')" style="font-size: 24px;"></a>-->
            <!--<div class="title-tip">-->
              <!--邀请人员加入企业-->
              <!--<i></i>-->
            <!--</div>-->
          <!--</div>-->
        </template>
      </div>
    </template>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  @-webkit-keyframes rock {
    0%,
    65% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    70% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    75% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    80% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    85% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    90% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    95% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    100% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  @keyframes rock {
    0%,
    65% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    70% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    75% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    80% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    85% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    90% {
      -webkit-transform: rotate(6deg);
      transform: rotate(6deg);
    }
    95% {
      -webkit-transform: rotate(-6deg);
      transform: rotate(-6deg);
    }
    100% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */
  {
    0%   {top: 25px;}
    100% {top: -25px;}
  }
  .white{
    .logged-header{
      .preview-file-name{
        font-size:20px;
        font-weight:500;
        color:rgb(33,37,48);
      }
    }
  }
  .logged-header {
    text-align: center;
    box-sizing: border-box;
    position: relative;
    height: 100%;
    padding: 0 240px;

    .logo-instance {
      position: absolute;
      left: 0;
      z-index: 10;
    }

    .new-notice {
      display: inline-block;
      position: absolute;
      left: 160px;
      z-index: 11;
      width: 84px;
      height: 25px;
      margin: 16px;
      background: url("~@/assets/images/new.png") no-repeat center center;
      background-size: contain;
      overflow: hidden;
      .notice-arrow {
        position: absolute;
        width: 12px;
        height: 16px;
        left: 8px;
        top: 2px;
        background: url("~@/assets/images/notice-arrow.png") no-repeat center center;
        background-size: contain;
        &.infinite {
          animation: myfirst 1.5s infinite ease-in-out;
          -webkit-animation: myfirst 1.5s infinite linear;
        }
      }
    }

    .preview-file-name {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 56px;
      line-height: 56px;
      color: #fff;
      font-size: 19px;
      text-align: center;
      font-weight: bold;
      float: left;
    }

    & > a {
      display: inline-block;
      margin: 0 20px;
      height: 100%;
      line-height: 56px;
      position: relative;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.55);

      &.active {
        color: #fff;

        &:after {
          content: "";
          display: inline-block;
          width: 100%;
          height: 3px;
          background: rgb(47, 165, 255);
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }

      &:hover {
        color: #fff;
        .submenu {
          display: block;
        }
      }
      .submenu {
        display: none;
        width: 220px;
        background: #FFFFFF;
        box-shadow: 0px 2px 16px 0px rgba(33, 37, 48, 0.2);
        border-radius: 2px;
        padding: 12px 0;
        left: -20px;
        ul {
          li {
            width: 220px;
            height: 48px;
            padding: 0 16px;
            box-sizing: border-box;
            background: #FFFFFF;
            font-weight: 400;
            color: rgba(33, 37, 48, 0.8);
            margin-top: 8px;
            &:first-child {
              margin-top: 0;
            }
            .submenu-icon {
              display: inline-block;
              width: 36px;
              height: 36px;
              line-height: 36px;
              margin: 6px 0;
              border-radius: 50%;
              background: #f2f2f2;
              i {
                vertical-align: baseline;
                color: #ffffff;
              }
              &.cyan  {
                background: #29CBD1;
              }

              &.blue {
                background: #2079FA;
              }

              &.green {
                background: #2CCC4A;
              }

              &.orange {
                background: #FF7C48;;
              }
            }
            .submenu-title {
              display: inline-block;
              text-align: left;
              /*width: 132px;*/
              padding: 0 12px;
              font-weight: 400;
              color: rgba(33, 37, 48, 0.8);
              font-size: 14px;
              line-height: 48px;
              box-sizing: border-box;
            }
            .submenu-mask {
              display: inline-block;
              width: 52px;
              margin: 14px 0;
              height: 20px;
              line-height: 18px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(33, 37, 48, 0.55);
              background: #FFFFFF;
              border-radius: 10px;
              border: 1px solid rgba(33, 37, 48, 0.15);
              box-sizing: border-box;
            }

            &:hover {
              background-color: #f3f4f7;
            }
          }
        }
      }
    }

    .right-options {
      position: absolute;
      top: 0;
      /*right: 8px;*/
      right: 24px;
      height: 100%;
      width: auto;
      z-index: 2000;

      & > * {
        float: right;
        margin-left: 24px;
        height: 100%;
        color: rgba(255, 255, 255, 0.55);

        &:hover {
          color: #fff;
        }

        position: relative;

        &:last-child {
          margin-left: 0;
        }
      }

      .user-info--cont {
        position: relative;

        & > * {
          display: inline-block;
          float: left;
        }

        .r2-icon-nav_expand_more {
          font-size: 20px;
          line-height: 56px;
          margin-left: 4px;
        }

        .switch-cont {
          display: none;
          position: absolute;
          top: 41px;
          right: -12px;
          width: 300px;
          padding-top: 16px;

          & > i {
            top: 10px;
            right: 24px;
            display: inline-block;
            width: 10px;
            height: 10px;
            background: rgb(255, 255, 255);
            transform: rotateZ(45deg);
            position: absolute;
          }

          &--main {
            min-height: 162px;
            height: auto;
            background: rgb(255, 255, 255);
            box-shadow: 0px 2px 16px 0px rgba(33, 37, 48, 0.2);
          }

          a {
            color: #212530;
          }

          .info--cont {
            width: 100%;
            height: 60px;
            padding: 25px 0 20px 0;
            box-sizing: content-box;
            border-bottom: 1px solid rgba(33, 37, 48, 0.1);

            & > * {
              float: left;
              display: block;
            }

            & > span {
              height: 48px;
              width: 48px;
              margin-top: 6px;
              margin-left: 24px;
              margin-right: 16px;
            }

            &__inner {
              width: 188px;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              height: 22px;
              color: #212530;
              line-height: 22px;
              /*margin-top: 19px;*/

              .user-name {
                height: 24px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(33, 37, 48, 1);
                line-height: 24px;
              }

              .space-process {
                width: 100%;
                height: 6px;
                margin-top: 8px;
                background: rgba(33, 37, 48, 0.1);
                display: flex;
                position: relative;
                &.is-warning {
                  .person-space {
                    background: #DF4952;
                  }
                  .enterprise-space {
                    background: #FFBDC1;
                  }
                }

                .person-space {
                  height: 6px;
                  background: rgba(32, 121, 250, 1);
                }

                .enterprise-space {
                  /*height:6px;*/
                  background: rgba(177, 209, 255, 1);

                  &:hover {
                    .tooltip-box {
                      display: block;
                    }
                  }

                  .tooltip-box {
                    display: none;
                    position: absolute;
                    animation: dialog-fade-in .3s;
                    padding-top: 6px;
                    top: 6px;
                    /*left: -40px;*/
                  }

                  .tooltip {
                    width: 80px;
                    border-radius: 4px;
                    padding: 10px;
                    box-sizing: border-box;
                    z-index: 2000;
                    font-size: 14px;
                    line-height: 24px;
                    min-width: 10px;
                    word-wrap: break-word;
                    background: rgba(33, 37, 48, 0.9);
                    color: #ffffff;
                    text-align: center;

                    &:after {
                      position: absolute;
                      display: block;
                      width: 0;
                      height: 0;
                      border-color: transparent;
                      border-style: solid;
                      content: " ";
                      margin-bottom: 12px;
                      top: 0;
                      left: 50%;
                      margin-left: -5px;
                      border-top-width: 0;
                      border-bottom-color: rgba(33, 37, 48, 0.9);
                      border-width: 6px;
                      border-top-width: 0;
                      border-bottom-color: rgba(33, 37, 48, 0.9);
                    }
                  }
                }
              }

              .space-info {
                height: 24px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(33, 37, 48, 0.75);
                line-height: 24px;
              }
            }
          }

          .link-list {
            padding: 8px 0;
            font-size: 14px;
            li {
              & > a {
                display: inline-block;
                width: 100%;
                height: 40px;
                line-height: 40px;
                text-align: left;
                box-sizing: border-box;
                padding: 0 36px 0 24px;
                position: relative;

                .r2-icon-nav_chevron_right {
                  font-size: 20px;
                  position: absolute;
                  right: 16px;
                  color: rgba(33, 37, 48, 0.55);
                }
              }

              &:hover {
                background: rgba(243, 244, 247, 1);
              }

              &.logout {
                display: block;
                width: 100%;
                height: 48px;
                line-height: 40px;
                text-align: left;
                margin-top: 8px;
                border-top: 1px solid rgba(33, 37, 48, 0.1);
                position: relative;

                &:before {
                  content: "";
                  height: 8px;
                  display: block;
                  background-color: #fff;
                }
              }
            }
          }
        }

        &:hover {
          .switch-cont {
            display: block;
          }
        }
      }

      .notice {
        font-size: 24px;
        line-height: 56px;

        &.tips:after {
          content: " ";
          display: inline-block;
          height: 6px;
          width: 6px;
          border-radius: 6px;
          position: absolute;
          background-color: red;
          right: 3px;
          top: 17px;
        }

        &.rock {
          transform-origin: center top;
          -webkit-animation: rock 1s 0s ease-in-out infinite;
          -moz-animation: rock 1s 0s ease-in-out infinite;
          -ms-animation: rock 1s 0s ease-in-out infinite;
          -o-animation: rock 1s 0s ease-in-out infinite;
          animation: rock 1s 0s ease-in-out infinite;
          animation-delay: 1s;
          -webkit-animation-delay: 1s; /* Safari 和 Chrome */
        }
      }

      .admin-icon--cont {
        width: 24px;
        height: 24px;
        margin-top: 16px;
        position: relative;

        .r2-icon-qiehuan, .r2-icon-yaoqing {
          font-size: 24px;
          color: rgba(255, 255, 255, 0.55);
          line-height: 1;
        }

        .title-tip {
          display: none;
          word-break: keep-all;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 16px 0px rgba(33, 37, 48, 0.2);
          position: absolute;
          top: 36px;
          left: 50%;
          padding: 5px 16px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(33, 37, 48, 0.8);
          line-height: 22px;
          transform: translateX(-50%);
          border-radius: 4px;

          i {
            width: 10px;
            height: 10px;
            transform: rotateZ(45deg);
            display: block;
            background-color: #fff;
            position: absolute;
            top: -5px;
            left: 50%;
            margin-left: -6px;
          }
        }

        &:hover {
          .r2-icon-qiehuan, .r2-icon-yaoqing {
            color: #fff;
          }

          .title-tip {
            display: block;
          }
        }
      }
    }

    .switch-content {
      display: none;
      position: absolute;
      right: -42px;
      top: 45px;
      z-index: 2001;
      padding-top: 10px;
      border-top: 0px;
      border-radius: 6px;
      box-shadow: 0px 2px 16px 0px rgba(33, 37, 48, 0.2);
      .icon-up {
        position: absolute;
        top: 5px;
        left: 168px;
        display: block;
        width: 0;
        height: 0;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        border-bottom: 6px solid #FFF;
      }

      hr {
        overflow: hidden;
        margin: auto 15px;
      }

      .switch-head {
        color: #212530;
        font-size: 14px;
        font-weight: 500;
        background: #FFF;
        border-radius: 6px 6px 0px 0px;
        padding: 25px 15px 0px;
        border-bottom: 1px solid rgba(33, 37, 48, 0.1);
      }

      .switch-box {
        padding: 10px 0px;
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
        border-top: none;
        background-color: #ffff;
      }
    }

    .prolink-btn {
      color: rgba(255, 255, 255, 0.55);

      &:hover {
        color: rgba(255, 255, 255, 1);
      }
    }

    .trial-center {
      height: 32px;
      display: inline-block;
      position: relative;

      &.show--switch-content {
        .prolink-btn.white {
          background: #eaf1ff;
        }

        .switch-content {
          display: block;
        }
      }

      &:hover {
        .switch-content {
          display: block;
        }
      }
      .switch-content {
        width: 260px;
        top: 50px;
        padding-top: 6px;
        animation: dialog-fade-in .3s;

        .icon-up {
          left: 200px;
          top: 0px;
        }
        &__null{
          width: 160px;
          .icon-up {
            left: 100px;
          }
        }
        .switch-head {
          padding: 0 0 0 24px;
          text-align: left;
          height: 56px;
          line-height: 56px;
          cursor: default;
        }

        .switch-box {
          min-height: 50px;
          height: auto;
          padding: 0;
          box-sizing: border-box;

          ul {
            list-style: none;
            margin: 0;
            padding-left: 0;
          }

          li {
            height: 64px;
            padding: 14px 24px;
            box-sizing: border-box;
            background-color: #fff;
            position: relative;

            a {
              /*display: block;*/
              width: 100%;
              height: 100%;
              color: #666;

              span {
                float: left;
                height: 100%;
                line-height: 36px;
                margin-right: 10px;
                padding: 0;
                color:rgba(33, 37, 48, 0.8);
                &.icon {
                  width: 36px;
                  height: 36px;
                  background-size: cover !important;
                }

                &:last-child {
                  margin-right: 0;
                  font-size: 16px;
                }
              }
            }

            &:hover {
              background-color: #f0f0f0;

              a {
                color: #000;
              }
            }

            &:last-child {
              border-bottom-right-radius: 6px;
              border-bottom-left-radius: 6px;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  /*.w-fade-in-linear-enter-active {*/
  /*animation: dialog-fade-in .6s;*/
  /*}*/
  /*.w-fade-in-linear-leave-active {*/
  /*animation: dialog-fade-out .6s;*/
  /*}*/
  @keyframes dialog-fade-in {
    0% {
      transform: translate3d(0, -10px, 0);
      opacity: 0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity: .8;
    }
  }

  @keyframes dialog-fade-out {
    0% {
      transform: translate3d(0, 0, 0);
      opacity: .8;
    }
    100% {
      transform: translate3d(0, -10px, 0);
      opacity: 0;
    }
  }
</style>
<script>
/* eslint-disable no-template-curly-in-string */
import Logo from '_c/Logo.vue'
import {mapState} from 'vuex'
import {findTopMenu} from '@/assets/utils'
// import {getCookie} from '@/assets/utils/CommonUtil'
import {on, off} from '@/assets/utils/index'
import {getElementsByClass} from '@/assets/utils/dom'
import commonService from '@/assets/service/common'
import _ from 'lodash'
// import {env} from '@/assets/js/config'
export default {
  name: 'HeaderLogged',
  data () {
    return {
      showNotice: false, // 是否显示新版公告
      isInfinite: true, // 新版公告gif动画，5S后结束动画
      showTooltip: false,
      showTrialCenterSwitch: true,
      showSwitchTimer: null,
      mouseEnterEvent: null,
      trialCenterList: [
        // {
        //   permissionId: 15,
        //   name: '计价依据',
        //   icon: require('@/assets/images/icon-jjyj.png')
        // }
      ]
    }
  },
  props: {
    noLogo: {
      type: Boolean,
      default: false
    },
    showAnimate: {
      type: Boolean,
      default: false
    },
    newMessage: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {
      }
    },
    pageTitle: {
      type: String,
      default: ''
    },
    capacity: {
      type: Object,
      default () {
        return {
          // 空间容量
          company: {
            // 企业
            total: 0,
            used: 0
          },
          personal: {
            // 个人
            total: 0,
            used: 0,
            staffUsed: 0
          }
        }
      }
    },
    // 历史上传 是否有新动态
    newUpload: {
      type: Number,
      default: 0 // 0: 无上传， 1：有工程上传， 2：有清单上传， 3：有组价上传
    },
    // 我的反馈 是否有新动态
    newFeedback: {
      type: Boolean,
      default: false
    },
    // 强制刷新header数据
    refreshIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      menuList: state => state.menus.menuList,
      leftMenus: state => state.menus.leftMenus,
      applicationPermission: state => state.menus.applicationPermission,
      databaseBlockRedirect: state => state.menus.databaseBlockRedirect
    }),
    // 1. 当前页面属于哪个模块(顶级菜单)
    nowActive () {
      findTopMenu(this.$route, this.menuList)
      return window.topMenuPath
    },
    // 2. 用户头像 背景图片设置
    portraitStyle () {
      let sty = ''
      if (this.userInfo && this.userInfo.portrait) {
        sty += 'background-image: url("' + this.userInfo.portrait + '");'
      }
      return sty
    }
  },
  mounted () {
    this.getAnnouncement()
    // this.$nextTick(() => {
    //   console.log(this.userInfo)
    // })
    const params = {
      language: 'cn',
      gray: document.domain
    }
    commonService.getTrialApps(params).then((res) => {
      if (+res.code === 200 && res.data) {
        this.trialCenterList = res.data
      }
    }).finally(() => {
      this.initShowSwitchTimer(true)
    })
  },
  methods: {
    // 获取用户是否已读新版公告状态
    getAnnouncement () {
      commonService.getAnnouncement().then(res => {
        if (res.code === 200 && res.data === 0) {
          this.showNotice = true
          // 新版公告gif动画，5S后结束动画
          setTimeout(() => {
            this.isInfinite = false
          }, 5000)
        }
      })
    },
    // 设置用户已读新版公告
    setAnnouncement () {
      this.sentLog(100101044)
      commonService.setAnnouncement().then(res => {
        if (res.code === 200) {
          this.showNotice = false
        } else {
          // this.$message.error(res.menus || '状态设置失败')
        }
      })
    },
    // 鼠标移动到个人信息 下拉按钮上是  主动获取 员工空间容量
    fetchPersonalStorage () {
      this.$emit('fetchPersonalStorageHandle')
    },
    // 1. 页头通用操作
    // clickHandle: _.debounce(function (type, action = '', redirectUrl = '') {
    clickHandle: _.debounce(function (type, action) {
      const userInfoSwitchCont = document.getElementById('userInfoSwitchCont')
      if (userInfoSwitchCont) {
        userInfoSwitchCont.style.display = 'none'
        setTimeout(() => {
          userInfoSwitchCont.style.display = ''
        }, 500)
      }
      // redirectUrl && this.accountSingleLogin(redirectUrl)
      this.$emit('clickHandle', {type, action})
    }, 800),
    // 1. 初始化 试用中心下拉框 计时器
    initShowSwitchTimer (init) {
      if (this.showSwitchTimer) {
        clearTimeout(this.showSwitchTimer)
        this.showSwitchTimer = null
      }
      if (init) {
        this.showSwitchTimer = setTimeout(() => {
          this.showTrialCenterSwitch = false
        }, 5000)
      }
      this.initTrialCenterSwitchMouseEvent(init)
    },
    // 1.1 初始化 试用中心 鼠标移入事件
    initTrialCenterSwitchMouseEvent (init) {
      const mouseEnterEventTags = getElementsByClass('trial-center')
      if (mouseEnterEventTags) {
        off(mouseEnterEventTags[0], 'mouseenter', this.mouseEnterEvent)
        off(mouseEnterEventTags[0], 'mouseleave', this.mouseLeaveEvent)
        // this.mouseEnterEvent = null
        if (init) {
          on(mouseEnterEventTags[0], 'mouseenter', this.mouseEnterEvent = () => {
            this.showTrialCenterSwitch = true
          })
          on(mouseEnterEventTags[0], 'mouseleave', this.mouseLeaveEvent = () => {
            this.showTrialCenterSwitch = false
          })
        }
      }
    },
    // 试用中心某个产品点击
    trialCenterItemClickHandle (item) {
      this.showTrialCenterSwitch = false
      this.openLinkNewTab(Object.assign(item, {
        appModule: 1,
        appId: item.id,
        zjySsoLogin: item.singleLogin
      }))
      switch (item.name) {
        case '计价依据':
          this.sentLog(100110018)
          break
        default:
      }
      // if (+item.permissionId === 15) {
      //   // 计价依据库
      //   switch (item.name) {
      //     case '计价依据':
      //       this.sentLog(100110018)
      //       const ZJYTOKEN = getCookie('ZJYTOKEN')
      //       const weburl = {
      //         dev: 'https://ebq-test.gfgwxw.top/#/login/sso/', //  开发环境
      //         test: 'https://ebq-test.glodon.com/#/login/sso/', // 测试环境
      //         pre: 'https://ebq-pre.glodon.com/#/login/sso/', // 预上线环境
      //         product: 'https://ebq.glodon.com/#/login/sso/' // 线上环境
      //       }
      //       const webUrl = weburl[env] || 'https://ebq.glodon.com/#/login/sso/'
      //       const redirectUrl = commonService.zjySsoLogin() + '?weburl=' + encodeURIComponent(webUrl) + '&token=' + ZJYTOKEN + '&gldDogNum=' + (getCookie('DOGNUM') || '')
      //       console.dir(redirectUrl)
      //       console.log('66666666666666666666666')
      //       window.open(redirectUrl)
      //       break
      //     default:
      //   }
      // }
    }
  },
  watch: {
    'databaseBlockRedirect': function () {
      // console.log('2222222222222222')
      if (this.leftMenus.length) {
        this.switchModule(this.leftMenus[0])
      }
    }
  },
  components: {
    Logo
  }
}
</script>
